<template>
  <CCard class="border-0 shadow-sm h-100">
    <CCardHeader class="bg-white border-bottom">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">
          <translate translate-context="payout.services">Eventi contribuenti</translate>
        </h5>
        <CBadge color="primary" shape="pill">
          {{ picaServices.length }}
        </CBadge>
      </div>
    </CCardHeader>
    <CCardBody class="p-0" style="max-height: 400px; overflow-y: auto;">
      <div v-if="picaServices.length === 0" class="text-center py-4 text-muted">
        <CIcon name="cipCalendar" size="2xl" class="mb-2 d-block mx-auto"/>
        <translate translate-context="payout.services">Nessun evento con vendite</translate>
      </div>
      
      <div v-else class="list-group list-group-flush">
        <div
          v-for="service in picaServices"
          :key="service.id"
          class="list-group-item border-left-0 border-right-0 px-3 py-3"
        >
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1">
              <div class="font-weight-bold text-truncate mb-1">
                {{ service.name }}
              </div>
              <div class="d-flex align-items-center text-muted small">
                <CIcon name="cipCalendar" size="sm" class="mr-1"/>
                <span v-if="service.from_date">{{ service.from_date | formatDate('DD/MM/YYYY') }}</span>
                <span v-else>-</span>
                <span class="mx-2">•</span>
                <span>{{ service.photos_sold || 0 }} foto vendute</span>
              </div>
            </div>
            <div class="text-right ml-3">
              <div class="font-weight-bold">
                {{ service.paid_gross | currency(currency) }}
              </div>
              <div class="text-muted small" v-if="service.paid_net">
                Netto: {{ service.paid_net | currency(currency) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CCardBody>
    <CCardFooter v-if="totalAmount" class="bg-light">
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-muted small">
          <translate translate-context="payout.services">Volume totale</translate>
        </div>
        <div class="font-weight-bold">
          {{ totalAmount | currency(currency) }}
        </div>
      </div>
    </CCardFooter>
  </CCard>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PicaServicesList',
  computed: {
    ...mapGetters('payout', ['statistics']),
    ...mapGetters('events', ['contract']),
    picaServices() {
      return this.statistics?.raw?.pica_services || []
    },
    currency() {
      return this.contract?.currency || 'EUR'
    },
    totalAmount() {
      // Somma dei paid_gross di tutti i servizi
      if (!this.picaServices.length) return null
      return this.picaServices.reduce((sum, service) => {
        return sum + parseFloat(service.paid_gross || 0)
      }, 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.list-group-item:hover {
  background-color: #f8f9fa;
}
</style>